module.exports = __webpack_public_path__ + "static/media/zip-icon.6a47d711.svg";